import React from 'react';
/**
 * `Confirm` is a small confirmation-page content wrapper.
 *
 * It renders:
 * - a reference heading (e.g. order number label)
 * - a subtitle/summary description
 * - optional child content (for additional confirmation components)
 * - an email confirmation line with an envelope icon
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';

type ConfirmProps = {
  subTitle: string;
  emailConfirmationText: string;
  orderNumbers: string[];
  children?: React.ReactNode;
  referenceText: string;
};

const Confirm = ({
  subTitle,
  emailConfirmationText,
  children,
  referenceText
}: ConfirmProps): JSX.Element => {
  return (
    <div>
      <p className='p2 bold m1-bottom'>{referenceText}</p>
      <p className='p2 m2-bottom cms' data-testid='page-summary-description'>
        {subTitle}
      </p>
      {children}
      <p className='p2 m2-top m1-bottom cms'>
        <FontAwesomeIcon
          icon={faEnvelope}
          className='primary-color m05-right cms-default-icon-colour'
        />
        {emailConfirmationText}
      </p>
    </div>
  );
};

export default Confirm;
